<template>
	<el-dialog :title="titleMap[mode]" :visible.sync="visible" width="1200px" center destroy-on-close @closed="$emit('closed')">
        <div style="display: flex;justify-content: space-between;">
            <div style="background-color: #999;color: #fff;padding: 20px 0px;border-radius: 8px;text-align: center;width: 120px;">
                <div :class="{_color: !form.apply_no}">
                    <div>第1步</div>
                    <div class="f_15">选择流程</div>
                </div>
                <div><i class="el-icon-bottom f_20 m_10"></i></div>
                <div :class="{_color: !form.apply_no}">
                    <div>第2步</div>
                    <div class="f_15">填写提交</div>
                </div>
                <div><i class="el-icon-bottom f_20 m_10"></i></div>
                <div :class="{_color: form.audit == 2}">
                    <div>第3步</div>
                    <div class="f_15">审批/处理</div>
                </div>
                <div><i class="el-icon-bottom f_20 m_10"></i></div>
                <div :class="{_color: form.audit == 3}">
                    <div>第4步</div>
                    <div class="f_15">申请完结</div>
                </div>
            </div>
            <div class="bs p_20 br_8" style="flex: 1;margin: 0 20px;">
                <el-scrollbar style="height: 60vh;">
                    <div class="c9" style="margin-left: 20px;margin-bottom: 20px;">
                        <span>流程单号：{{form.apply_no}}</span>
                        <el-button type="primary" class="fr" plain size="small">{{form.audit_text}}</el-button>
                    </div>
                    <el-form :model="form" :disabled="mode=='show'" ref="dialogForm" label-width="100px">
                        <CustomFormItem :form="form" :item="item" v-for="item in formArr" :key="item.name" v-if="!['id', 'state', 'audit'].includes(item.name)" />
                        <!-- <el-form-item :label="item.title + '：'" v-for="item in formArr" :key="item.name" v-if="!['id', 'state'].includes(item.name)">
                            <el-input v-if="item.type == 'text'" v-model="form[item.name]" :disabled="item.permit_edit == 0" placeholder="请输入" style="width: 80%;" />
                            <el-input v-if="item.type == 'number'" v-model="form[item.name]" :disabled="item.permit_edit == 0" placeholder="请输入" style="width: 300px;" />
                            <el-date-picker v-if="item.type == 'datetime'" v-model="form[item.name]" :disabled="item.permit_edit == 0" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
                            <el-select v-if="item.type == 'option'" v-model="form[item.name]" :disabled="item.permit_edit == 0" placeholder="请选择">
                                <el-option v-for="it in item.options" :key="it.id" :label="it.name" :value="it.id"> </el-option>
                            </el-select>

                            <el-upload
                                v-if="item.type == 'image'" :disabled="item.permit_edit == 0"
                                multiple :limit="10" name="image" :action="uploadUrl" list-type="picture-card" accept=".jpg,.png,.jpeg" :file-list="form[item.name]"
                                :on-success="(res,file)=>{handleImgSuccess(res, file, item.name)}"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="(file, fileList)=>handleRemoveImg(file, fileList, item.name)"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>

                            <el-upload
                                v-if="item.type == 'file'" :disabled="item.permit_edit == 0"
                                multiple :limit="10" name="file" :action="uploadFileUrl" :file-list="form[item.name]"
                                :on-success="(res, file)=>{handleFileSuccess(res, file, item.name)}"
                                :on-remove="(file, fileList)=>handleRemoveFile(file, fileList, item.name)"
                                :on-exceed="handleExceed"
                            >
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            
                            <div v-if="item.type == 'admin'" style="display: flex;flex-direction: column;">
                                <el-select v-model="form[item.name]" :disabled="item.permit_edit == 0" clearable placeholder="请选择员工" @visible-change='selectAdmin' style="width: 300px;">
                                    <el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id" />
                                </el-select>
                            </div>

                            <el-cascader v-if="item.type == 'depart'" v-model="form[item.name]" :disabled="item.permit_edit == 0" :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" style="width: 300px;" @visible-change="getDepartmentLists"></el-cascader>

                            <el-select v-if="item.type == 'user'" v-model="form[item.name]" placeholder="请选择" size="medium" style="width: 300px;"
                                remote :remote-method="(val) => getUserLists(val)"  filterable clearable @visible-change="getUserLists" v-loading="userLoading" :disabled="item.permit_edit == 0"
                            >
                                <el-option v-for="(item, index) in userArr" :key="item.id" :label="item.name + ' / ' + item.phone" :value="item.id"></el-option>
                                <el-pagination @current-change="userPageChange" :current-page="userSearch.page" :page-size="userSearch.limit" :total="userSearch.total" small
                                    layout="prev, next" prev-text="上一页" next-text="下一页" >
                                </el-pagination>
                            </el-select>
                        </el-form-item> -->
                    </el-form>
                </el-scrollbar>
            </div>
            <div style="display: flex;flex-direction: column;flex:1;" v-if="form.apply_no">
                <div style="margin-bottom: 10px;">流程进度：</div>
                <el-scrollbar style="height: 60vh;">
                <el-steps direction="vertical" :active="process_active" finish-status="success" :space="100">
                    <el-step v-for="(item, index) in process" :key="index">
                        <span slot="title">
                            <div>
                                <span style="color: #999;">{{item.node_name}}：</span>
                                <span style="color: #000;font-weight: normal;">{{item.node_admin}}</span>
                                <span style="color: #67C23A;margin-left: 10px;" v-if="item.audit == 2">{{item.audit_text}}</span>
                                <span style="color: #E6A23C;margin-left: 10px;" v-else-if="item.audit == 1">{{item.audit_text}}</span>
                                <span style="color: #999;margin-left: 10px;" v-else>{{item.audit_text}}</span>
                                <span style="color: #999;margin-left: 10px;">{{item.audit_time}}</span>
                            </div>
                            <div v-if="index > 0 && (index + 1 != process.length) && (index + 1 <= process_active)">
                                <el-form ref="auditForm" label-width="60px">
                                    <el-form-item label="备注：" style="margin-bottom: 10px;">
                                        <el-input v-model="item.remark" :disabled="process_active > index + 1" placeholder="" size="small" style="width: 80%;" />
                                    </el-form-item>
                                    <el-form-item label="附件："  style="margin-bottom: 10px;">
                                        <el-upload :disabled="process_active > index + 1"
                                            multiple :limit="10" name="file"
                                            :action="uploadFileUrl"
                                            :on-success="(res, file)=>{handleAuditFileSuccess(res, file, item)}"
                                            :on-remove="(file, fileList)=>handleRemoveAuditFile(file, fileList, item)"
                                            :on-exceed="handleExceed"
                                            :on-preview="handlePreview"
                                            :file-list="item.file">
                                            <el-button size="small" type="primary" v-if="process_active <= index + 1">点击上传</el-button>
                                        </el-upload>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </span>
                    </el-step>
                </el-steps>
                </el-scrollbar>
            </div>
        </div>
        <span slot="footer">
            <el-checkbox v-model="form.submit_audit" v-if="form.audit == 1" :true-label="1" :false-label="0">提交审核</el-checkbox>
            <el-button style="margin-left: 20px;" @click="visible = false;">取消</el-button>
            <template v-if="mode != 'show'">
            <el-button type="primary" v-if="form.audit == 1" :loading="isSaveing" @click="submit">确定</el-button>

            <el-button type="success" v-if="form.audit == 2 && form.current_node_admin_id.includes(loginInfo.admin_id)" @click="audit(2)">通过</el-button>
            <el-button type="warning" v-if="form.audit == 2 && form.current_node_admin_id.includes(loginInfo.admin_id)" @click="audit(3)">拒绝</el-button>
            </template>
        </span>
	</el-dialog>
</template>

<script>
import base from '@/request/base.js'
import CustomFormItem from "@/components/CustomForm/CustomFormItem.vue"
import { oaApply, oaAudit, oaReapply, oaTemplate, fieldLists, DepartmentLists, adminLists, userLists, customizeAdd, customizeEdit, customizeDetail } from "../../../request/apis.js"
import { mapGetters } from 'vuex'
export default {
    emits: ['success', 'closed'],
    components: { CustomFormItem },
    data() {
        return {
            mode: "add",
            titleMap: {
                add: '发起流程',
                edit: '编辑',
                show: '查看'
            },
            visible: false,
            isSaveing: false,
            formInit: {},
            form: {
                apply_no: '',
                audit: 1,
                state: 1,
                audit_text: '待提审',
                submit_audit: 1,
                name: '',
            },
            //验证规则
            rules: {
                avatar:[
                    {required: true, message: '请上传头像'}
                ],
                userName: [
                    {required: true, message: '请输入登录账号'}
                ],
                name: [
                    {required: true, message: '请输入真实姓名'}
                ],
                password: [
                    {required: true, message: '请输入登录密码'},
                    {validator: (rule, value, callback) => {
                        if (this.form.password2 !== '') {
                            this.$refs.dialogForm.validateField('password2');
                        }
                        callback();
                    }}
                ],
                password2: [
                    {required: true, message: '请再次输入密码'},
                    {validator: (rule, value, callback) => {
                        if (value !== this.form.password) {
                            callback(new Error('两次输入密码不一致!'));
                        }else{
                            callback();
                        }
                    }}
                ],
                dept: [
                    {required: true, message: '请选择所属部门'}
                ],
                group: [
                    {required: true, message: '请选择所属角色', trigger: 'change'}
                ]
            },
            template_id: 0,
            dialogVisible: false,
            dialogImageUrl: '',
            current_template: {},
            current_apply: {},
            templateList: [],
            adminList: [],
            userSearch: {page: 1, limit: 10, total: 0},
            userLoading: false,
            userArr: [],
            departArr: [],
            formArr: [],
            fieldArr: [],
            process: [],
            process_active: 1,
            audit_remark: '',
            audit_file: [],
        }
    },
    computed: {
        ...mapGetters(['loginInfo']),
        uploadUrl: {
            get() {
                return base.url + "/index/uploadImg?category=3&sid=" + this.loginInfo.sid + '&token=' + this.loginInfo.token + '&uid=' + this.loginInfo.admin_id;
            }
        },
        uploadFileUrl: {
            get() {
                return base.url + "/index/uploadFile?category=3&sid=" + this.loginInfo.sid + '&token=' + this.loginInfo.token + '&uid=' + this.loginInfo.admin_id;
            }
        },
    },
    mounted() {
        this.formInit = Object.assign({}, this.form);
    },
    methods: {
        //显示
        async open(table, template_id, apply_id = 0, mode = 'add'){
            console.log('editdialog', table, template_id, apply_id, mode)
            this.mode = mode;
            this.apply_id = apply_id;
            this.template_id = template_id;

            if(mode == 'add'){
                this.form = Object.assign({}, this.formInit);
                this.getFieldLists(table);
            }else if(mode == 'edit' || mode == 'show'){
                let res = await oaApply({apply_id: this.apply_id}, 3);
                if(res.code != 0){
                    return this.$message.error(res.msg);
                }
                this.form = JSON.parse(JSON.stringify({...this.form, ...res.data.data, apply_no: res.data.apply_no, audit: res.data.audit, audit_text: res.data.audit_text, current_node_admin_id: res.data.current_node_admin_id }));
                console.log('this.form', this.form)
                this.process = res.data.process;
                this.process_active = res.data.process_active;
                this.formArr = res.data.form;
                this.selectAdmin(true);
                this.getUserLists(true);
                this.getDepartmentLists(true);
            }
            this.visible = true;
            return this
        },

        async selectAdmin(query){
            if (!query) {
                return false;
            }
            const res = await adminLists({limit: 1000})
            if (res.code) {
                return this.$message.error(res.msg)
            }
            this.adminList = res.data;
        },
        async getUserLists(query, page){
            if(!query) return;
            this.userSearch.page = page ? page : this.userSearch.page;
            this.userLoading = true;
            var res = await userLists(this.userSearch);
            this.userLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.userArr = res.data;
            this.userSearch.total = res.count;
        },
        userPageChange(val){
            this.getUserLists(true, val);
        },
        async getDepartmentLists(){
            var res = await DepartmentLists({top: 1});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data[0]['children'] || [];
        },
        async getFieldLists(table){
            var res = await fieldLists({table});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.formArr = res.data.filter(({name}) => !['created_by', 'created_time', 'updated_by', 'updated_time'].includes(name));
        },
        
        async submit(){
            this.isSaveing = true;
            let result = await oaApply({ ...this.form, template_id: this.template_id, apply_id: this.apply_id || 0 }, this.form.id ? 4 : 0);
            this.isSaveing = false;
            if (result.code == 0) {
                this.$emit('success', this.form, this.mode)
                this.visible = false;
                this.$message.success(result.msg);
            } else {
                this.$message.error(result.msg);
            }
        },

        async audit(state){
            let params = { 
                ...this.form, 
                template_id: this.template_id, 
                apply_id: this.apply_id,

                audit: state, 
                remark: this.process[this.process_active - 1].remark, 
                file: this.process[this.process_active - 1].file,
            };
            let result = await oaAudit(params, 0);
            if (result.code == 0) {
                this.$emit('success', this.form, this.mode)
                this.visible = false;
                this.$message.success(result.msg);
            } else {
                this.$message.error(result.msg);
            }
        },
        
        //表单注入数据
        setData(data){
            Object.assign(this.form, data)
        },

        handleImgSuccess(res, file, name) {
            console.log('handleImgSuccess', res, file);
            if (res.code) {
                return this.$message.error('上传失败:' + res.msg);
            }
            this.form[name] = this.form[name] || [];
            this.form[name].push({url: res.data.url, name: res.data.filename, uid: file.uid});
            console.log('handleImgSuccess', name, this.form)
        },
        handleFileSuccess(res, file, name) {
            if (res.code) {
                return this.$message.error('上传失败:' + res.msg);
            }
            this.form[name] = this.form[name] || [];
            this.form[name].push({url: res.data.url, name: res.data.filename, uid: file.uid});
        },
        handleRemoveImg(file, fileList, name) {
            console.log('handleRemoveImg', file, fileList, name);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleRemoveFile(file, fileList, name) {
            console.log('handleRemoveFile', file, fileList, name);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },

        handleAuditFileSuccess(res, file, item) {
            if (res.code) {
                return this.$message.error('上传失败:' + res.msg);
            }
            item.file = item.file || [];
            item.file.push({url: res.data.url, name: res.data.filename, uid: file.uid});
        },
        handleRemoveAuditFile(file, fileList) {
            console.log('handleRemoveFile', file, fileList);
        },
        handlePreview(file) {
            let url = file.url;
            if (!url && file.raw) {
                url = URL.createObjectURL(file.raw); // 本地文件转换
            }
            url = base.domain + url;
            console.log('handlePreview', url)
            window.open(url); // 直接打开链接预览
        }
    }
}
</script>

<style scoped>
/deep/.el-scrollbar .el-scrollbar__wrap { overflow-x: hidden; }
/deep/.el-upload-list--picture-card .el-upload-list__item { width: 100px; height: 100px; }
/deep/.el-upload--picture-card { width: 100px; height: 100px; line-height: 100px; }
</style>
